/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Operations,
  ResourceReservation,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kReservations } from "./reservations";
import { kResources } from "./resources";

export const kResourceReservations: (ResourceReservation & Operations)[] = [
  {
    id: "3179fa35-231e-4e59-b766-e4af39c709ca",
    userId: kReservations[19].user!.id!,
    createdByUserId: kReservations[19].user!.id!,
    reservationId: kReservations[19].id,
    resourceId: kResources[0].id,
    dateFrom: "2025-01-11T06:21:23.2323",
    dateTo: "2025-01-11T09:21:23.232Z",
    repeatedReservation: true,
  },
  {
    id: "4e202003-fa8c-46ff-977a-42c28f93a68d",
    userId: kReservations[6].user!.id!,
    createdByUserId: kReservations[6].user!.id!,
    reservationId: kReservations[6].id,
    resourceId: kResources[1].id,
    dateFrom: "2025-03-06T05:00:17.1717",
    dateTo: "2025-03-06T12:00:17.171Z",
    repeatedReservation: false,
  },
  {
    id: "2aaff25a-8d6f-409a-912f-6d4b37615af1",
    userId: kReservations[2].user!.id!,
    createdByUserId: kReservations[2].user!.id!,
    reservationId: kReservations[2].id,
    resourceId: kResources[2].id,
    dateFrom: "2025-01-20T03:46:30.3030",
    dateTo: "2025-01-20T03:46:30.303Z",
    repeatedReservation: false,
  },
  {
    id: "9c81e0c9-dcdf-42bf-92e4-cd56213d18a3",
    userId: kReservations[8].user!.id!,
    createdByUserId: kReservations[8].user!.id!,
    reservationId: kReservations[8].id,
    resourceId: kResources[3].id,
    dateFrom: "2025-01-07T09:06:18.1818",
    dateTo: "2025-01-07T10:06:18.181Z",
    repeatedReservation: true,
  },
  {
    id: "09ee5573-33e2-496c-8b34-001a8af20e2a",
    userId: kReservations[12].user!.id!,
    createdByUserId: kReservations[12].user!.id!,
    reservationId: kReservations[12].id,
    resourceId: kResources[0].id,
    dateFrom: "2025-03-18T07:39:51.5151",
    dateTo: "2025-03-18T15:39:51.515Z",
    repeatedReservation: false,
  },
  {
    id: "722d1a26-9886-4e73-8618-f6317b553224",
    userId: kReservations[4].user!.id!,
    createdByUserId: kReservations[4].user!.id!,
    reservationId: kReservations[4].id,
    resourceId: kResources[1].id,
    dateFrom: "2025-01-12T06:37:50.5050",
    dateTo: "2025-01-12T13:37:50.505Z",
    repeatedReservation: true,
  },
  {
    id: "9bfc3b1b-28bd-4dd1-8961-e73c730d1192",
    userId: kReservations[15].user!.id!,
    createdByUserId: kReservations[15].user!.id!,
    reservationId: kReservations[15].id,
    resourceId: kResources[4].id,
    dateFrom: "2025-03-02T05:07:20.2020",
    dateTo: "2025-03-02T10:07:20.202Z",
    repeatedReservation: false,
  },
  {
    id: "90132ea7-cbaf-4b19-9def-ef21451d31dd",
    userId: kReservations[0].user!.id!,
    createdByUserId: kReservations[0].user!.id!,
    reservationId: kReservations[0].id,
    resourceId: kResources[2].id,
    dateFrom: "2025-03-01T03:31:39.3939",
    dateTo: "2025-03-01T11:31:39.393Z",
    repeatedReservation: false,
  },
  {
    id: "fa817c76-96ac-4b2a-b981-1732a72fa926",
    userId: kReservations[6].user!.id!,
    createdByUserId: kReservations[6].user!.id!,
    reservationId: kReservations[6].id,
    resourceId: kResources[2].id,
    dateFrom: "2025-03-03T02:49:02.022",
    dateTo: "2025-03-03T08:49:02.022Z",
    repeatedReservation: false,
  },
  {
    id: "1f078295-cb8c-40eb-b11e-93fd5587245f",
    userId: kReservations[16].user!.id!,
    createdByUserId: kReservations[16].user!.id!,
    reservationId: kReservations[16].id,
    resourceId: kResources[4].id,
    dateFrom: "2025-02-02T10:41:43.4343",
    dateTo: "2025-02-02T14:41:43.434Z",
    repeatedReservation: true,
  },
  {
    id: "f4a60736-524e-4b20-a121-dee752f1f09f",
    userId: kReservations[10].user!.id!,
    createdByUserId: kReservations[10].user!.id!,
    reservationId: kReservations[10].id,
    resourceId: kResources[1].id,
    dateFrom: "2025-02-19T06:00:00.000",
    dateTo: "2025-02-19T15:00:00.000Z",
    repeatedReservation: true,
  },
  {
    id: "ce0c01f9-059b-47ea-9cdc-ca986347ca9d",
    userId: kReservations[13].user!.id!,
    createdByUserId: kReservations[13].user!.id!,
    reservationId: kReservations[13].id,
    resourceId: kResources[2].id,
    dateFrom: "2025-01-10T11:42:43.4343",
    dateTo: "2025-01-10T14:42:43.434Z",
    repeatedReservation: true,
  },
  {
    id: "34025697-4060-401e-bb82-ed249364865a",
    userId: kReservations[17].user!.id!,
    createdByUserId: kReservations[17].user!.id!,
    reservationId: kReservations[17].id,
    resourceId: kResources[4].id,
    dateFrom: "2025-04-01T10:29:36.3636",
    dateTo: "2025-04-01T10:29:36.363Z",
    repeatedReservation: true,
  },
  {
    id: "2d3385ac-2c21-4eae-aa0c-a89af0c665ee",
    userId: kReservations[16].user!.id!,
    createdByUserId: kReservations[16].user!.id!,
    reservationId: kReservations[16].id,
    resourceId: kResources[3].id,
    dateFrom: "2025-03-18T02:08:29.2929",
    dateTo: "2025-03-18T05:08:29.292Z",
    repeatedReservation: true,
  },
  {
    id: "3552eba6-f877-414d-aed3-4251f3501939",
    userId: kReservations[0].user!.id!,
    createdByUserId: kReservations[0].user!.id!,
    reservationId: kReservations[0].id,
    resourceId: kResources[1].id,
    dateFrom: "2025-02-15T05:47:34.3434",
    dateTo: "2025-02-15T05:47:34.343Z",
    repeatedReservation: true,
  },
  {
    id: "a5b8c44e-0ccc-46c3-ac82-9b3dd7f80e89",
    userId: kReservations[4].user!.id!,
    createdByUserId: kReservations[4].user!.id!,
    reservationId: kReservations[4].id,
    resourceId: kResources[4].id,
    dateFrom: "2025-02-23T04:23:53.5353",
    dateTo: "2025-02-23T13:23:53.535Z",
    repeatedReservation: false,
  },
  {
    id: "2c7d1d38-8e30-4950-8525-c0aeabe4e4f3",
    userId: kReservations[5].user!.id!,
    createdByUserId: kReservations[5].user!.id!,
    reservationId: kReservations[5].id,
    resourceId: kResources[3].id,
    dateFrom: "2025-03-29T02:31:37.3737",
    dateTo: "2025-03-29T10:31:37.373Z",
    repeatedReservation: false,
  },
  {
    id: "07a57d95-474c-4975-85b7-88893dd2ea10",
    userId: kReservations[1].user!.id!,
    createdByUserId: kReservations[1].user!.id!,
    reservationId: kReservations[1].id,
    resourceId: kResources[1].id,
    dateFrom: "2025-02-18T11:50:34.3434",
    dateTo: "2025-02-18T16:50:34.343Z",
    repeatedReservation: false,
  },
  {
    id: "cfcd8e09-720c-4167-911f-d0ff43e23d1f",
    userId: kReservations[18].user!.id!,
    createdByUserId: kReservations[18].user!.id!,
    reservationId: kReservations[18].id,
    resourceId: kResources[0].id,
    dateFrom: "2025-01-09T09:36:01.011",
    dateTo: "2025-01-09T09:36:01.011Z",
    repeatedReservation: false,
  },
  {
    id: "b1c738a7-070e-4b1a-b0f4-0911c788c92f",
    userId: kReservations[10].user!.id!,
    createdByUserId: kReservations[10].user!.id!,
    reservationId: kReservations[10].id,
    resourceId: kResources[2].id,
    dateFrom: "2025-03-16T11:20:59.5959",
    dateTo: "2025-03-16T16:20:59.595Z",
    repeatedReservation: false,
  },
];
